import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import moment from 'moment';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'flex-start',
    flex: '1 1 auto',
    marginLeft: '10px',
    cursor: 'pointer',
    maxHeight: '58px',
    '&.unread': {
      fontWeight: 'bolder',
    },
    '&.noarchive': {},
  },
  firstLine: {
    maxWidth: '183px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    wordWrap: 'break-word',
    '&.with-second-line': {
      whiteSpace: 'nowrap',
    },
    '&.no-second-line': {
      display: '-webkit-box',
      '-webkit-line-clamp': '2',
      '-webkit-box-orient': 'vertical',
    },
  },
  secondLine: {
    fontSize: '12px',
  },
};

class ConnectionListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { classes, unread, onTouchTap, lastUnread, name, noArchive } = this.props;
    const secondLineClass = lastUnread ? 'with-second-line' : 'no-second-line';
    return (
      <div className={`${classes.container}${(unread ? ' unread' : '')}${(noArchive ? ' noarchive' : '')}`} onTouchTap={onTouchTap}>
        <div className={`${classes.firstLine} ${secondLineClass}`}>{name}</div>
        {lastUnread ? <div className={classes.secondLine}>{moment(lastUnread).fromNow()}</div> : undefined}
      </div>
    );
  }
}

ConnectionListItem.propTypes = {
  classes: PropTypes.object,
  lastUnread: PropTypes.string,
  name: PropTypes.string,
  onTouchTap: PropTypes.func,
  unread: PropTypes.bool,
  noArchive: PropTypes.bool,
};


export default injectSheet(styles)(ConnectionListItem);



// WEBPACK FOOTER //
// ./src/app/components/workspace/connection-list-item.jsx